<template>
  <v-dialog
    v-model="dialog"
    overlay
    persistent
    max-width="400px"
    transition="dialog-transition"
  >
    <template #activator="{ attrs }">
      <v-btn
        :loading="searching"
        @click="OpenPayment"
        v-bind="attrs"
        block
        color="success"
        >PUY
        <v-icon right>fas fa-usd</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        <div class="row">
          <div class="col text-truncate">
            <strong class="blue--text">{{ propertyInfo.PropertyName }}</strong>
          </div>
          <div class="col-2">
            <v-btn icon @click="close">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>

      <v-card-text class="">
        <p class="grey lighten-3">
          <cashDisplay
            small
            :isloading="loading"
            :Balance="ExpBalance"
          ></cashDisplay>
        </p>

        <v-form v-model="valid" ref="paymentForm">
          <BaseDate
            v-model="PayDate"
            outlined
            :rules="v => !!v || 'Date is required'"
          >
          </BaseDate>

          <BaseNumInput
            :rules="[paymentRule]"
            outlined
            v-model.trim="Amount"
            label="Amount"
          ></BaseNumInput>
          <v-select
            outlined
            v-model.trim="cashType"
            :items="GetCashTypes"
            :rules="[v => !!v || 'Cash Type is required']"
            label="Cash Type"
            required
          ></v-select>
          <v-text-field
            name="InfoFildName"
            label="Info"
            id="InfoFildid"
            outlined
            v-model.trim="Details"
            :rules="[v => !!v || 'Provide Infomation']"
          ></v-text-field>

          <!-- <p>{{ Amount }}</p> -->
          <!-- <p>{{ propertyInfo }}</p> -->
        </v-form>
        <p v-if="ErrMsg" v-html="ErrMsg" class="text-center"></p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          width="200px"
          :loading="loading"
          @click="OnSavePayment"
          :disabled="!valid"
          color="success"
          >Puy</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import cashDisplay from "@/components/coman/cashViewNoRow.vue";
export default {
  components: { cashDisplay },
  props: {
    propertyInfo: { type: Object, required: true },
    ExpBalance: { type: Array, required: true },
    BaseURL: { type: String, required: true },
    Onfinsh: { type: Function, required: true },
  },
  data() {
    return {
      ErrMsg: "",
      loading: false,
      searching: false,
      dialog: false,
      valid: false,
      AccountBlce: 0,
      Cashes: [],
      cashType: "",
      PayDate: "",
      Amount: 0,
      Details: "",
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.$nextTick(() => {
          this.PayDate = this.Current().date;
          // this.Amount = this.DueAmount;
          //   this.Amount = 0;
        });
      }
    },
  },
  computed: {
    ...mapGetters(["UsersToken", "GetCashTypes"]),
    Balance() {
      return `${this.AccountBlce.toLocaleString()} ${this.UsersToken.CashBase}`;
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";
      this.PayDate = "";
      this.Details = "";
      this.Amount = 0;
      this.AccountBlce = 0;
      this.$refs.paymentForm.resetValidation();
    },

    GetReq(url, query) {
      if (!url) url = "/Account";
      if (!query) query = { acc: [{ AccountType: 1 }, { AccountType: 3 }] };

      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    OpenPayment() {
      //   this.searching = true;

      this.dialog = true;
      //   this.GetReq().then(cash => {
      //       // console.log(blce.data);

      //       this.searching = false;
      //       this.Cashes = cash.data;
      //     })
      //     .catch(err => {
      //       console.log(err);
      //       this.searching = false;
      //     });
    },
    OnSavePayment() {
      this.ErrMsg = "";
      if (this.$refs.paymentForm.validate()) {
        let data = {
          Description: this.propertyInfo,
          cashType: this.cashType,
          Amount: this.Amount,
          Details: this.Details,
          date: this.PayDate,
          time: this.Current().time,
        };
        this.loading = true;
        this.$store
          .dispatch("INSERT_ONLY", { url: this.BaseURL + "/puy", data })
          .then(() => {
            // console.log(val);
            this.loading = false;
            this.Onfinsh();
            this.close();
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.ErrMsg = error && error.response && error.response.data;
          });
      }
    },
    paymentRule(v) {
      //   v = v.replace(/,/g, "");
      //   let andCon = v && v.replace(/,/g, "") > 0 && v.replace(/,/g, "");
      return (v && v.replace(/,/g, "") > 0) || "Invalid Amount";
    },
  },
};
</script>
